import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Divider,
  Text,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { useMutationDeleteAccount } from "../../../store/useMutationDeleteAccount";
import { Account } from "../../../types/Account";
import { ConfirmAnswerInputField } from "../../forms/ConfirmAnswerInputField";
import { FormModal } from "../../modals/FormModal";

type DeleteAccountFormValues = {
  answer: string;
};

export function DeleteAccountModal({
  account,
  disclosure,
}: {
  account: Account;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const form = useForm<DeleteAccountFormValues>({
    defaultValues: {
      answer: "",
    },
    mode: "onTouched",
  });

  const mutationDeleteAccount = useMutationDeleteAccount(account._id);

  const onSubmit = async () => {
    await mutationDeleteAccount.mutateAsync();
  };

  return (
    <FormModal
      disclosure={disclosure}
      form={form}
      title="Delete account"
      submitButtonText="Delete account"
      successTitle="Account deleted"
      errorTitle="Failed to delete account"
      colorScheme="red"
      onSubmit={onSubmit}
    >
      <VStack w="full" spacing={4} align="stretch">
        <Text>
          You are deleting the account:{" "}
          <Text as="span" fontWeight="bold">
            {account.fullName}
          </Text>
        </Text>

        <Alert status="error" borderRadius="md" alignItems="flex-start">
          <AlertIcon />

          <VStack align="flex-start" spacing={2}>
            <AlertTitle>Deleting this account is permanent</AlertTitle>

            <AlertDescription>
              This will delete all transaction history and tax calculations for
              the account, and you won&apos;t be able to access any Crypto Tax
              Reports.
            </AlertDescription>

            <AlertDescription>
              Any active subscriptions will also be terminated.
            </AlertDescription>
          </VStack>
        </Alert>

        <Divider />

        <ConfirmAnswerInputField
          form={form}
          name="answer"
          expectedAnswer={account.fullName}
          label="account name"
          autoFocus
        />
      </VStack>
    </FormModal>
  );
}
